import { wait } from "./Wait";

interface ISwaggerResponse {
    status: number;
}

export async function withRetry<TResult>(
    call: () => Promise<TResult & ISwaggerResponse>,
    retries: number = 3
) {
    let attempt = 1;

    while (attempt <= retries) {
        try {
            return await call();
        }
        catch { /* empty */ }

        await wait(3000);

        attempt++;
    }

    throw new Error("Retries exceeded");
}